(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var bar = document.querySelector('[data-announcement-bar]');
    var track = document.querySelector('[data-announcement-track]');
    if (!bar || !track) return;

    var items = track.querySelectorAll('[data-announcement-item]');
    if (items.length <= 1) return;

    var currentIndex = 0;
    var interval = 3500;

    function rotate() {
      items.forEach(function(item, i) {
        item.style.display = i === currentIndex ? '' : 'none';
      });
    }

    function checkRotation() {
      if (window.innerWidth <= 768) {
        items.forEach(function(item, i) {
          item.style.display = i === currentIndex ? '' : 'none';
        });
      } else {
        items.forEach(function(item) {
          item.style.display = '';
        });
      }
    }

    checkRotation();
    window.addEventListener('resize', checkRotation);

    setInterval(function() {
      if (window.innerWidth <= 768 && items.length > 1) {
        currentIndex = (currentIndex + 1) % items.length;
        rotate();
      }
    }, interval);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (function() {
    var sortSelect = document.querySelector('[data-sort-select]');
    if (!sortSelect) return;

    sortSelect.addEventListener('change', function() {
      var url = new URL(window.location);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('header-drawer')) {
    customElements.define('header-drawer', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.openButton = this.querySelector('[data-drawer-open]');
        if (!this.dialog || !this.openButton) return;

        this.openButton.addEventListener('click', () => this.dialog.showModal());
        this.querySelector('[data-drawer-close]').addEventListener('click', () => this.dialog.close());
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.dialog.close();
        });
        this.dialog.addEventListener('close', () => this.openButton.focus());
      }
    });
  }

  if (!customElements.get('mega-menu')) {
    customElements.define('mega-menu', class extends HTMLElement {
      connectedCallback() {
        const canHover = window.matchMedia('(hover: hover)').matches;
        this.items = Array.from(this.querySelectorAll('[data-mega-item]'));

        this.items.forEach((item) => {
          const button = item.querySelector('[data-mega-toggle]');
          let timer;

          button.addEventListener('click', () => {
            if (item.classList.contains('is-open') && !item.openedByHover) {
              this.close(item);
            } else {
              this.open(item);
            }
            item.openedByHover = false;
          });

          if (canHover) {
            item.addEventListener('mouseenter', () => {
              clearTimeout(timer);
              timer = setTimeout(() => {
                if (!item.classList.contains('is-open')) {
                  this.open(item);
                  item.openedByHover = true;
                }
              }, 90);
            });
            item.addEventListener('mouseleave', () => {
              clearTimeout(timer);
              timer = setTimeout(() => this.close(item), 180);
            });
          }

          item.addEventListener('focusout', (event) => {
            if (!item.contains(event.relatedTarget)) this.close(item);
          });
          item.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && item.classList.contains('is-open')) {
              this.close(item);
              button.focus();
            }
          });
        });
      }

      open(item) {
        this.items.forEach((other) => {
          if (other !== item) this.close(other);
        });
        item.classList.add('is-open');
        item.querySelector('[data-mega-toggle]').setAttribute('aria-expanded', 'true');
      }

      close(item) {
        item.classList.remove('is-open');
        item.openedByHover = false;
        item.querySelector('[data-mega-toggle]').setAttribute('aria-expanded', 'false');
      }
    });
  }

  if (!customElements.get('predictive-search')) {
    customElements.define('predictive-search', class extends HTMLElement {
      connectedCallback() {
        this.input = this.querySelector('input[type="search"]');
        this.results = this.querySelector('[data-results]');
        this.activeIndex = -1;
        if (!this.input || !this.results || !this.dataset.url) return;

        this.input.addEventListener('input', () => {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.search(), 250);
        });
        this.input.addEventListener('focus', () => {
          if (this.input.value.trim() && this.results.innerHTML.trim()) this.open();
        });
        this.input.addEventListener('keydown', (event) => this.onKeydown(event));
        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget)) this.close();
        });
        document.addEventListener('click', (event) => {
          if (!this.contains(event.target)) this.close();
        });
      }

      search() {
        const terms = this.input.value.trim();
        if (this.controller) this.controller.abort();
        if (!terms) {
          this.results.innerHTML = '';
          this.close();
          return;
        }

        this.controller = new AbortController();
        const params = new URLSearchParams({
          q: terms,
          section_id: 'predictive-search',
          'resources[type]': 'product,collection,query,page',
          'resources[limit]': '4',
          'resources[options][unavailable_products]': 'last'
        });

        fetch(`${this.dataset.url}?${params}`, { signal: this.controller.signal })
          .then((response) => {
            if (!response.ok) throw new Error(`HTTP ${response.status}`);
            return response.text();
          })
          .then((html) => {
            const content = new DOMParser()
              .parseFromString(html, 'text/html')
              .querySelector('[data-predictive-content]');
            this.results.innerHTML = content ? content.innerHTML : '';
            this.activeIndex = -1;
            this.results.innerHTML.trim() ? this.open() : this.close();
          })
          .catch((error) => {
            if (error.name !== 'AbortError') this.close();
          });
      }

      getOptions() {
        return Array.from(this.results.querySelectorAll('[role="option"]'));
      }

      onKeydown(event) {
        const options = this.getOptions();

        if (event.key === 'Escape') {
          this.close();
          return;
        }
        if (this.results.hidden || options.length === 0) return;

        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          const step = event.key === 'ArrowDown' ? 1 : -1;
          this.activeIndex = (this.activeIndex + step + options.length) % options.length;
          options.forEach((option, index) => option.setAttribute('aria-selected', index === this.activeIndex));
          const active = options[this.activeIndex];
          this.input.setAttribute('aria-activedescendant', active.id);
          active.scrollIntoView({ block: 'nearest' });
        } else if (event.key === 'Enter' && this.activeIndex > -1) {
          event.preventDefault();
          const active = options[this.activeIndex];
          const target = active.matches('a, button') ? active : active.querySelector('a, button');
          if (target) target.click();
        }
      }

      open() {
        this.results.hidden = false;
        this.input.setAttribute('aria-expanded', 'true');
      }

      close() {
        this.results.hidden = true;
        this.activeIndex = -1;
        this.input.setAttribute('aria-expanded', 'false');
        this.input.removeAttribute('aria-activedescendant');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    
  (function() {
    // Quantity changes go through /cart/change.js with the Section Rendering
    // API: Shopify returns this section re-rendered by Liquid, so prices use
    // the store's money format and strings stay translated. Lines are addressed
    // by item key (stable when other lines are removed) and requests are queued
    // so rapid clicks are applied in order.
    var queue = Promise.resolve();

    function getCartPage() {
      return document.querySelector('[data-cart-section]');
    }

    function updateQuantity(key, quantity) {
      var cartPage = getCartPage();
      if (!cartPage) return;
      var sectionId = cartPage.getAttribute('data-cart-section');
      cartPage.classList.add('is-loading');

      queue = queue.then(function() {
        var root = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
        return fetch(root + 'cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({
            id: key,
            quantity: quantity,
            sections: [sectionId],
            sections_url: window.location.pathname
          })
        })
        .then(function(res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function(cart) {
          var html = cart.sections && cart.sections[sectionId];
          if (!html) throw new Error('Missing section HTML');
          var fresh = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-cart-section]');
          var current = getCartPage();
          if (!fresh || !current) throw new Error('Missing cart markup');
          current.replaceWith(fresh);
          document.querySelectorAll('[data-cart-count]').forEach(function(badge) {
            badge.textContent = cart.item_count;
            badge.hidden = cart.item_count === 0;
          });
        })
        .catch(function(err) {
          console.error('Cart update failed:', err);
          // Fall back to a regular form submit so the change is not lost
          var form = document.getElementById('cart-form');
          if (form) form.submit();
        });
      });
    }

    function getInput(el) {
      var key = el.getAttribute('data-key');
      return document.querySelector('[data-cart-section] [data-qty-input][data-key="' + key + '"]');
    }

    // Delegated listeners: they keep working after the section is re-rendered
    document.addEventListener('click', function(event) {
      var btn = event.target.closest('[data-cart-section] [data-qty-minus], [data-cart-section] [data-qty-plus]');
      if (!btn) return;
      var input = getInput(btn);
      if (!input) return;
      var val = parseInt(input.value, 10) || 0;
      var newVal = btn.hasAttribute('data-qty-plus') ? val + 1 : Math.max(0, val - 1);
      input.value = newVal;
      updateQuantity(btn.getAttribute('data-key'), newVal);
    });

    document.addEventListener('change', function(event) {
      var input = event.target.closest('[data-cart-section] [data-qty-input]');
      if (!input) return;
      var val = Math.max(0, parseInt(input.value, 10) || 0);
      input.value = val;
      updateQuantity(input.getAttribute('data-key'), val);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["password"]) return;
  try {
    
  (function() {
    var dialog = document.getElementById('PasswordDialog');
    var openButton = document.querySelector('[data-password-open]');
    var closeButton = document.querySelector('[data-password-close]');
    if (!dialog || !openButton) return;

    openButton.addEventListener('click', function() {
      dialog.showModal();
      var input = dialog.querySelector('input[type="password"]');
      if (input) input.focus();
    });
    closeButton.addEventListener('click', function() { dialog.close(); });
    dialog.addEventListener('click', function(event) {
      if (event.target === dialog) dialog.close();
    });

    // Reopen the dialog when Shopify returns a wrong-password error
    if (dialog.querySelector('.landing__error')) dialog.showModal();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (function() {
    // Thumbnail switching
    var thumbs = document.querySelectorAll('[data-thumb-index]');
    var mainImage = document.getElementById('product-main-image');
    thumbs.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        var url = this.getAttribute('data-thumb-url');
        var srcset = this.getAttribute('data-thumb-srcset');
        var alt = this.getAttribute('data-thumb-alt');
        if (mainImage && url) {
          mainImage.style.opacity = '0';
          setTimeout(function() {
            // The main image is rendered with a srcset; the browser ignores
            // a new src unless srcset is updated as well.
            if (srcset) {
              mainImage.setAttribute('srcset', srcset);
            } else {
              mainImage.removeAttribute('srcset');
            }
            mainImage.src = url;
            if (alt !== null) { mainImage.alt = alt; }
            mainImage.style.opacity = '1';
          }, 150);
        }
        thumbs.forEach(function(t) { t.classList.remove('is-active'); });
        this.classList.add('is-active');
      });
    });

    // Quantity buttons
    var qtyInput = document.getElementById('quantity');
    var qtyMinus = document.querySelector('#product-form [data-qty-minus]');
    var qtyPlus = document.querySelector('#product-form [data-qty-plus]');

    if (qtyInput && qtyMinus) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
    }
    if (qtyInput && qtyPlus) {
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }

    // Variant switching (reads data injected via script tag in HTML)
    var variantsData = document.getElementById('product-variants-data');
    var variantSelectors = document.querySelectorAll('[data-option-index]');
    var variantIdInput = document.querySelector('[data-variant-id]');
    var priceElement = document.querySelector('[data-price]');
    var compareElement = document.querySelector('[data-compare-price]');
    var saleBadge = document.querySelector('[data-sale-badge]');
    var submitBtn = document.querySelector('[data-add-to-cart]');
    var submitText = document.querySelector('[data-add-to-cart-text]');

    if (!variantsData || variantSelectors.length === 0) return;

    var config = JSON.parse(variantsData.textContent);
    var variants = config.variants;
    var addText = config.addText;
    var soldText = config.soldText;

    function getSelectedOptions() {
      var opts = [];
      variantSelectors.forEach(function(sel) {
        opts.push(sel.value);
      });
      return opts;
    }

    function findVariant(opts) {
      return variants.find(function(v) {
        return v.options.every(function(opt, i) {
          return opt === opts[i];
        });
      });
    }


    function updateVariant() {
      var opts = getSelectedOptions();
      var variant = findVariant(opts);
      if (!variant) return;

      variantIdInput.value = variant.id;

      // Prices are pre-formatted in Liquid with the store's money format
      var prices = config.prices[variant.id] || {};
      var variantOnSale = variant.compare_at_price > variant.price;

      if (priceElement && prices.price) {
        priceElement.textContent = prices.price;
        priceElement.classList.toggle('product-info-page__price--sale', variantOnSale);
      }

      if (compareElement) {
        compareElement.textContent = variantOnSale ? prices.compare : '';
        compareElement.hidden = !variantOnSale;
      }

      if (saleBadge) {
        saleBadge.hidden = !variantOnSale;
      }

      if (submitBtn && submitText) {
        if (variant.available) {
          submitBtn.disabled = false;
          submitBtn.classList.remove('is-disabled');
          submitText.textContent = addText;
        } else {
          submitBtn.disabled = true;
          submitBtn.classList.add('is-disabled');
          submitText.textContent = soldText;
        }
      }

      var url = new URL(window.location);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
    }

    variantSelectors.forEach(function(sel) {
      sel.addEventListener('change', updateVariant);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
